import Collapsible from 'react-native-collapsible';
export default Collapsible;
//# sourceMappingURL=Collapsible.js.map